<template lang="pug">
div
  section.fullBg
    .step1
      .title
        img(src='/images/event/treasure-hunt/logo.png')
      .depositPro
        h2 DEPOSIT PROGRESS : RM{{$numeral(depoAmt).format("0,0")}} / RM{{$numeral(targetAmt).format("0,0")}}
        .progress-container
          #myProgressBar.progress-bar(:style="'width:'+depoProgress+'%'")
          .progressValue
        ul
          li.pointer(:class="{'active unlock': tier > 0}" @click="boxClick(0)")
            img(v-if="tier < 1" src='/images/event/treasure-hunt/box.png')
            img(v-else src='/images/event/treasure-hunt/unbox.png')
            span Free rm2
            small ANY DEPO
          li.pointer(:class="{'active unlock': tier > 1}" @click="boxClick(1)")
            img(v-if="tier < 2" src='/images/event/treasure-hunt/box.png')
            img(v-else src='/images/event/treasure-hunt/unbox.png')
            span FREE RM8
            small ACCUMULATED RM200
          li.pointer(:class="{'active unlock': tier > 2}" @click="boxClick(2)")
            img(v-if="tier < 3" src='/images/event/treasure-hunt/box.png')
            img(v-else src='/images/event/treasure-hunt/unbox.png')
            span FREE RM10
            small ACCUMULATED RM400
          li.pointer(:class="{'active unlock': tier > 3}" @click="boxClick(3)")
            img(v-if="tier < 4" src='/images/event/treasure-hunt/box.png')
            img(v-else src='/images/event/treasure-hunt/unbox.png')
            span FREE RM15
            small ACCUMULATED RM666
      .centerBlocks
        //- img(src='/images/event/treasure-hunt/steps.png')
        img(:src="`/images/event/treasure-hunt/${tier}.png`")
        span.linkOverlay.t-0(v-if="tier >= 0" @click="clickAct(0)")
        span.linkOverlay.t-1(v-if="tier >= 1" @click="clickAct(1)")
        span.linkOverlay.t-2(v-if="tier >= 2" @click="clickAct(2)")
        span.linkOverlay.t-3(v-if="tier >= 3" @click="clickAct(3)")
        //- template(v-if="prevTier == null")
        //-   span.linkOverlay(:class="`t-${tier}`" @click="clickAct(tier)")
        //- template(v-if="prevTier !== null")
        //-   span.linkOverlay(:class="`t-${prevTier}`" @click="clickAct(prevTier)")
        //-   span.linkOverlay(:class="`t-${tier}`" @click="clickAct(tier)")
    .popupContent.d-flex(v-if="showPop")
      .centerImg(ref="rewardPop")
        img.pointer(:src="`/images/event/treasure-hunt/p${tier}.png`" @click="$router.push('/inbox').catch(err => {})")
        //- router-link.btnLink(to="inbox")
        a.closePopup(href='javascript:void(0)' @click="togglePop")
    //- step2 two
    //- .step2
    //-   .title
    //-     img(src='/images/event/treasure-hunt/logo.png')
    //-   .depositPro
    //-     h2 DEPOSIT PROGRESS : RM0/RM666
    //-     .progress-container
    //-       #myProgressBar.progress-bar(style='width: 15%;')
    //-       .progressValue
    //-     ul
    //-       li.active.glow
    //-         img(src='/images/event/treasure-hunt/boxglow.png')
    //-         span Free rm2
    //-         small ANY DEPO
    //-       li
    //-         img(src='/images/event/treasure-hunt/box.png')
    //-         span FREE RM8
    //-         small ACCUMULATED RM200
    //-       li
    //-         img(src='/images/event/treasure-hunt/box1.png')
    //-         span FREE RM10
    //-         small ACCUMULATED RM400
    //-       li
    //-         img(src='/images/event/treasure-hunt/box1.png')
    //-         span FREE RM15
    //-         small ACCUMULATED RM666
    //-   .centerBlocks
    //-     img(src='/images/event/treasure-hunt/steps2.png')
    //-     span.linkOverlay
    //- // popup
    //- .popupContent.step3
    //-   .centerImg
    //-     img(src='/images/event/treasure-hunt/popup.png')
    //-     a.btnLink(href='#')
    //-     a.closePopup(href='#')
    //- // step3 three
    //- .step4
    //-   .title
    //-     img(src='/images/event/treasure-hunt/logo.png')
    //-   .depositPro
    //-     h2 DEPOSIT PROGRESS : RM0/RM666
    //-     .progress-container
    //-       #myProgressBar.progress-bar(style='width: 20%;')
    //-       .progressValue
    //-     ul
    //-       li.active.unlock
    //-         img(src='/images/event/treasure-hunt/unbox.png')
    //-         span Free rm2
    //-         small ANY DEPO
    //-       li
    //-         img(src='/images/event/treasure-hunt/box.png')
    //-         span FREE RM8
    //-         small ACCUMULATED RM200
    //-       li
    //-         img(src='/images/event/treasure-hunt/box1.png')
    //-         span FREE RM10
    //-         small ACCUMULATED RM400
    //-       li
    //-         img(src='/images/event/treasure-hunt/box1.png')
    //-         span FREE RM15
    //-         small ACCUMULATED RM666
    //-   .centerBlocks
    //-     img(src='/images/event/treasure-hunt/steps4.png')
    .container
      .content-padding
        template(v-if="getLanguage=='my'")
          h4 TERMA DAN SYARAT
          h4 Level 1: Free RM2
          h5 T&C
          ul
            li Buat sebarang deposit untuk menikmati Free RM2 bonus!
            li Turnover: X3
            li Pengeluaran maksimum: RM20
            li Boleh dimainkan di EpicWin dan MegaH5
          h4 Level 2: Free RM8
          h5 T&C
          ul
            li Kumpulkan jumlah deposit RM200 dan nikmati Free RM8 bonus!
            li Turnover: X3
            li Pengeluaran maksimum: RM80
            li Boleh dimainkan di EpicWin dan MegaH5
          h4 Level 3: Free RM10
          h5 T&C
          ul
            li Capai jumlah deposit RM400 dan nikmati Free RM10 bonus!
            li Turnover: X3
            li Pengeluaran maksimum: RM100
            li Boleh dimainkan di EpicWin dan MegaH5
          h4 Level 4: Free RM15
          h5 T&C
          ul
            li Deposit jumlah RM666 dan dapatt Free RM15 bonus!
            li Turnover: X3
            li Pengeluaran maksimum: RM150
            li Boleh dimainkan di EpicWin dan MegaH5
          
          h3 Terma & Syarat Umum
          ul
            li Pengeluaran dihadkan kepada 5 kali sehari
            li EpicWin berhak sepenuhnya untuk menamatkan akaun ahli sekiranya berlaku pelanggaran T&C tanpa notis awal
            li Jumlah pengeluaran minimum adalah RM10
        template(v-if="getLanguage=='en'")
          h4 TERMS AND CONDITIONS
          h4 Level 1: Free RM2
          h5 T&C:
          ul
            li Simply make any deposit to enjoy a Free RM2 bonus!
            li Turnover: X3
            li Maximum withdrawal: RM20
            li Available for play on EpicWin and MegaH5
          h4 Level 2: Free RM8
          h5 T&C:
          ul
            li Accumulate a total deposit of RM200 and unlock a Free RM8 reward!
            li Turnover: X3
            li Maximum withdrawal: RM80
            li Available for play on EpicWin and MegaH5
          h4 Level 3: Free RM10
          h5 T&C:
          ul
            li Reach a total deposit of RM400 and enjoy a Free RM20 bonus!
            li Turnover: X3
            li Maximum withdrawal: RM100
            li Available for play on EpicWin and MegaH5
          h4 Level 4: Free RM15
          h5 T&C:
          ul
            li Deposit a total of RM666 and claim an exciting Free RM15 reward!
            li Turnover: X3
            li Maximum withdrawal: RM150
            li Available for play on EpicWin and MegaH5
          h3 General Terms and Conditions
          ul
            li Withdrawal is limited to 5 times per day.
            li EpicWin reserves all rights to terminate members' accounts in case of T&C violations without prior notice
            li Minimum withdrawal amount is RM10
        template(v-if="getLanguage=='zh'")
          h4 条款与条件
          h4 第1级：免费 RM2
          h5 T&C:
          ul
            li 只需存入任意金额，即可享受免费 RM2 奖励！
            li 流水要求：X3
            li 最高提款金额：RM20
            li 适用于 EpicWin 和 MegaH5
          h4 第2级：免费 RM8
          h5 T&C:
          ul
            li 累积存款满 RM200，即可解锁免费 RM8 奖励！
            li 流水要求：X3
            li 最高提款金额：RM80
            li 适用于 EpicWin 和 MegaH5
          h4 第3级：免费 RM10
          h5 T&C:
          ul
            li 累积存款满 RM400，即可享受免费 RM10 奖励！
            li 流水要求：X3
            li 最高提款金额：RM100
            li 适用于 EpicWin 和 MegaH5
          h4 第4级：免费 RM15
          h5 T&C:
          ul
            li 存款累计达 RM666，即可领取精彩的免费 RM15 奖励！
            li 流水要求：X3
            li 最高提款金额：RM150
            li 适用于 EpicWin 和 MegaH5
          h3 一般条款与条件
          ul
            li 每日最多提款 5 次
            li 若违反条款与条件，EpicWin 有权在无事先通知的情况下终止会员账户
            li 最低提款金额为 RM10
  //- .showGift(:class="{'d-block': showPrize == true}")
    img(:src="`/images/lucky-spin/popup${prizeWon}.jpg`" @click="goTo")
    //- img(:src="`/images/lucky-spin/popup.jpg`" @click="goTo")
    .button-center.text-center
      button.login-btn.rounded-pill(@click.stop="closePop")
        i.fa-solid.fa-sync
        | Spin Again
</template>
<script>
export default{
	data(){
		return{
      startRender: false,
			goDepo:true,
      depoAmt:"",
      targetAmt: 666,
      depoProgress: "",
      prevTier: null,
      tier: 0,
      showPop:false
		}
	},
	computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    chunkedToday(){
      let chunkSize = 2;
      let result = [];

      for (let i = 0; i < this.resToday.length; i += chunkSize) {
        result.push(this.resToday.slice(i, i + chunkSize));
      }
      return result;
    },
    chunkedPrev(){
      let chunkSize = 2;
      let result = [];

      for (let i = 0; i < this.resPrev.length; i += chunkSize) {
        result.push(this.resPrev.slice(i, i + chunkSize));
      }
      return result;
    }
  },
	watch:{
    sessionToken(newState, oldState){
      if(newState === '' || newState === undefined){
        this.goDepo = true
        this.showPop = false
        this.depoAmt = 0
        this.depoProgress = 0
        this.tier = 0
      }else{
        this.tierDeposit()
      }
    }
  },
  mounted() {
    // this.addStylesheet();
    window.scroll(0,0)
    document.body.classList.add("custom-font");
    this.tierDeposit()
  },
  beforeDestroy() {
    // this.removeStylesheet();
    document.body.classList.remove("custom-font");
  },
	methods:{
    openChat(){
      LiveChatWidget.call("maximize");
    },
    togglePop(){
      this.showPop = !this.showPop
      if(this.showPop == true){
        var hFull    = $('.t-header').outerHeight(true);
        this.$nextTick(() => {
          this.$refs.rewardPop.style.scrollMarginTop = `${hFull*4}px`;
          this.$refs.rewardPop.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
       
      }
    },
    claimAct(){
      this.openChat()
      this.togglePop()
    },
    tierDeposit(){
      if (this.sessionToken) {
        this.startRender = true
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/tierDeposit", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              this.depoAmt = response.data.info[0].deposit_amount
              this.targetAmt =  response.data.info[0].target_amount
              this.depoProgress = parseFloat(this.depoAmt) / this.targetAmt * 100
              
              if(response.data.info[0].deposit_amount > 0){
                this.goDepo = false
                this.tier = response.data.tier.reduce((acc, item) => item.unlocked ? item.level : acc, 0)
                if(this.tier > 0){
                  this.prevTier = this.tier-1
                }
              }else{
                this.goDepo = true
                this.tier = 0
              }
              this.startRender = false
            } else {
              this.startRender = false
              this.goDepo = true
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            this.startRender = false
            this.goDepo = true
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
          });
      }
    },
    depoAct(){
      if(this.isLoggedIn){
				this.$router.push("/deposit").catch(err => {});
			}else{
				this.$router.push("/login").catch(err => {});
			}
    },
    clickAct(src){
      if(src == this.tier){
        this.depoAct()
      }else{
        this.togglePop()
      }
    },
    boxClick(src){
      if(src >= this.tier){
        this.depoAct()
      }else{
        this.togglePop() 
      }
    },
	}
}
</script>
<style lang="css" scoped>
* {
    box-sizing: border-box;
}

.fullBg {
  background-image: url('/images/event/treasure-hunt/bg.jpg');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: 100% auto;

  background-color: #2f0449;
  position: relative;
  max-width: 800px;
  margin: auto;
}

.title,
.gift,
.lockImg {
  text-align: center;
}



.title img {
  max-width: 90%;
  margin: auto;
}

.title {
  cursor: pointer;
  margin-bottom: 50px;
}

.container {
  position: relative;
  padding: 0 10px;
  margin: 0 auto;
  max-width: 1360px;
}

.content-padding {
  padding-top: 50px;
  padding-bottom: 50px;
  color: #fff;
}




.centerBlocks {
  padding-top: 30px;
  position: relative;
}

.centerBlocks img {
  max-width: 98%;
  padding-top: 10px;
  padding-bottom: 30px;
  margin: auto;
  display: block;
}

.linkOverlay {
  position: absolute;
  width: 220px;
  height: 170px;
  display: block;
  top: 170px;
  right: 210px;
  cursor: pointer;
}

.actionBtn {
  text-align: center;
  font-size: 26px;
  color: #fff;
  font-weight: 600;
}

.actionBtn img {
  max-width: 400px;
  cursor: pointer;
}

.popupContent {
  background-color: hsl(0deg 0% 0% / 50%);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;

  align-items: center;
}

.popupContent img {
  max-width: 100%;
  margin: auto;
  display: block;
}

.popupContent .centerImg {
  position: relative;
}

.popupContent a.btnLink {
  position: absolute;
  display: block;
  width: 36%;
  height: 60px;
  bottom: 228px;
  left: 0;
  right: 0;
  margin: auto;
}

.popupContent a.closePopup {
  position: absolute;
  display: block;
  /* width: 72px; */
  width: 150px;
  height: 72px;
  top: 86px;
  right: 62px;
}

.result {
  width: 95%;
  border: 8px solid #61168c;
  margin: auto;
  border-radius: 20px;
  color: #fff;
}

.result table {
  width: 100%;
  font-size: 24px;
}

.result table th,
.result table td {
  padding: 20px;
  font-weight: 800;
  text-align: center;
  text-transform: uppercase;
}

.result table th {
  color: #ffd108;
}

.step2,
.step3,
.step4 {
  display: none;
}

.checkNumber {
  cursor: pointer;
}

.resultView {
  background-image: url('/images/event/treasure-hunt/resultbg.png');
  background-size: 100% 100%;
  text-align: center;
  color: #fff;
  padding: 60px;
  margin: 20px 0px;
}

.resultView h3 {
  font-size: 40px;
  font-weight: 900;
  margin: 0px;
}

.resultView h4 {
  font-size: 30px;
  font-weight: 900;
  color: #01ff19;
  margin: 0px;
}

.resultView table {
  width: 100%;
  font-size: 40px;
  font-weight: 800;
}

.resultView table td {
  padding: 10px;
}

.yesterdayReport {
  display: none;
}

.yesterdayPopup .clickTab {
  left: 0;
}

.yesterdayPopup {
  display: none;
}

.actionBtn .winning {
  width: 450px;
  margin-top: 40px;
}


.depositPro {
  background-image: url('/images/event/treasure-hunt/progressbarbg.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-radius: 30px;
  overflow: hidden;
  max-width: 90%;
  margin: auto;
  color: #fff;
  padding: 25px;
}

.depositPro h2 {
  margin: 0px;
  color: #fff;
  text-shadow: 3px 3px 2px #000;
  font-size: 26px;
  font-weight: 800;
}

.depositPro ul {
  padding: 0px;
  list-style: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 100%;
  margin: 20px auto;
  margin-top: 40px;
  font-family: "Changa One", sans-serif;
}

.depositPro ul li span {
  display: block;
  font-size: 26px;
  text-align: center;
  font-weight: normal;
  text-transform: uppercase;
  -webkit-text-stroke: 1px #673AB7;
  -webkit-text-fill-color: white;
  text-shadow: 1px 1px 1px #ffffff, -2px 3px 0 #9C27B0;
}

.depositPro ul li small {
  text-align: center;
  font-family: "Montserrat", serif;
  display: block;
  font-size: 10px;
}

.depositPro ul li img {
  max-width: 65%;
  margin: auto;
  display: block;
  margin-bottom: 10px;
  opacity: 0.8;

}


.depositPro ul li.active.glow span {
  -webkit-text-fill-color: #ffd800;
  color: #ffd800;
}

.depositPro ul li.active.glow img {
  opacity: 1;
  max-width: 72%;
  margin-bottom: 0px;
}

.depositPro ul li.active.unlock img {
  max-width: 87%;
  opacity: 1;
}

.depositPro ul li.active.unlock span {
  color: #00ff77;
  -webkit-text-fill-color: #00ff77;
}

.depositPro ul li {
  position: relative;
  width: 25%;
}

.depositPro ul li:before {
  content: '';
  background-image: url('/images/event/treasure-hunt/arrow.png');
  width: 22px;
  height: 20px;
  display: inline-block;
  position: absolute;
  top: -42px;
  left: 0;
  right: 0;
  background-size: 100% auto;
  margin: auto;
}

/* .depositPro ul li.active~li img {
    opacity: 1;
} */



.depositPro ul li:after {
  content: '';
  background-image: url('/images/event/treasure-hunt/plus.png');
  width: 12px;
  height: 12px;
  display: inline-block;
  position: absolute;
  right: -8px;
  background-size: 100% auto;
  margin: auto;
  bottom: 18px;
}

.depositPro ul li:last-child:after {
  display: none;
}


.progress-container {
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  border: 3px solid #000;
  max-width: 100%;
  margin: 10px auto;
  background-color: #48256f;
  position: relative;
}

.progress-bar {
  width: 0;
  height: 20px;
  background-color: #17e61b;
  text-align: center;
  line-height: 30px;
  color: white;
  border-radius: 20px;
  transition: all 0.2s ease-in-out;
}

.progressValue {
  text-shadow: 2px 2px 2px #000;
  font-size: 23px;
  font-weight: 800;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  top: 0;
  bottom: 0;
}


.topHeading {
  background-color: #c40000;
  color: #fff;
  padding: 20px;
  margin-left: -10px;
  margin-right: -10px;
  font-size: 17px;
  font-weight: 700;
  text-shadow: 1px 1px 0px #000;
  text-transform: uppercase;
}

.topHeading span {
  background-color: #fff;
  color: #460b6c;
  font-size: 20px;
  text-shadow: none;
  padding: 8px 20px;
  border-radius: 30px;
  margin-right: 10px;
}

.footer-content-padding {
  padding: 50px;
}

.footer-content-padding p {
  margin: 0px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
}

/* .step4 .depositPro ul li.active span {
    color: #17e61b;
}

.step4 .depositPro ul li.active img {
    opacity: 1;
    max-width: 65%;
} */

.closePopup {}


@media (max-width:480px) {
  .closePopup{
    top: 35px !important;
    right: 25px !important;
  }
  .t-1{
    height: 160px !important;
    width: 180px !important;
    top: 250px !important;
    left: 20px !important;
  }
  .t-2{
    height: 180px !important;
    width: 180px !important;
    top: 350px !important;
    right: 20px !important;
  }
  .t-3{
    height: 100px !important;
    width: 1000px !important;
    right: 110px !important;
  }
  .linkOverlay {
    /* height: 20px;
    width: 100px;
    top: 160px;
    right: 108px; */
    height: 120px;
    width: 150px;
    top: 100px;
    right: 110px;
  }

  .popupContent a {
    bottom: 95px;
  }

  .depositPro {
    padding: 15px;
    border-radius: 0px;
  }

  .depositPro h2 {
    font-size: 16px;
  }

  .depositPro ul li small {
    font-size: 8px;
  }

  .progressValue {
    font-size: 16px;
  }

  .progress-bar {
    height: 20px;
  }

  .depositPro ul li:before {
    width: 18px;
    height: 18px;
    top: -28px;
    background-repeat: no-repeat;
  }

  .depositPro ul li img {
    max-width: 60%;
  }

  .depositPro ul li span {
    font-size: 14px;
  }

  .depositPro ul li:after {
    right: -7px;
    width: 12px;
    height: 12px;
    top: 16px;
    bottom: initial;
  }

  .title .depositPro img {
    max-width: 60%;
  }

  .depositPro ul {
    max-width: 100%;
    align-items: start;
    margin-top: 26px;
  }

  .topHeading {
    padding: 10px;
    font-size: 12px;
    position: relative;
    padding-left: 78px;
  }

  .topHeading span {
    position: absolute;
    left: 10px;
    font-size: 15px;
    padding: 6px 10px;
  }

  .footer-content-padding {
    padding: 15px;
  }

  .footer-content-padding p {
    font-weight: 400;
    font-size: 12px;
    margin-bottom: 5px;
  }
}


/* .t-0{
  top: 125px !important;
  right: 130px !important;
} */
.t-1{
  top: 350px;
  left: 40px;
  width: 350px;
  height: 350px;
}

.t-2{
  top: 570px;
  width: 370px;
  height: 300px;
  right: 30px;
}
.t-3{
  top: auto;
  bottom: 50px;
  width: 370px;
  right: 270px;
  height: 350px;
}


@media(min-width: 481px) and (max-width: 767px){
  .closePopup{
    top: 50px !important;
    right: 30px !important;
  }
  .t-0{
    top: 125px !important;
    right: 100px !important;
    width: 350px;
    height: 190px;
  }
  .t-1{
    height: 280px;
    width: 250px;
  }
  .t-2{
    height: 300px;
    width: 250px;
    top: 380px;
    right: 0;
  }
  .t-3{
    height: 100px !important;
    width: 1000px !important;
    right: 110px !important;
  }
}

@media(min-width: 620px) and (max-width: 767px){
  .closePopup{
    top: 70px !important;
    right: 50px !important;
  }
  .t-2{
    top: 520px;
    width: 370px;
    height: 300px;
    right: 0;
  }
}


@media(min-width: 768px){
  
}
</style>